import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { StarIcon } from 'lucide-react';
const testimonials = [{
  text: 'Estábamos al borde de separarnos. Este PDF nos dio herramientas concretas para hablar sin pelear. En una semana ya se sentía diferente.',
  author: 'Lucía y Martín',
  location: 'Buenos Aires',
  color: 'from-[#C4B5FD] to-[#A78BFA]',
  avatar: 'https://randomuser.me/api/portraits/women/44.jpg'
}, {
  text: 'Lo mejor es que es práctico. No es teoría, son cosas que aplicas esa misma noche.',
  author: 'Carolina R.',
  location: 'Córdoba',
  color: 'from-[#A78BFA] to-[#8B5CF6]',
  avatar: 'https://randomuser.me/api/portraits/women/68.jpg'
}, {
  text: 'El Contrato de Convivencia fue un antes y un después. Por primera vez sentimos que somos equipo.',
  author: 'Diego y Sofía',
  location: 'Rosario',
  color: 'from-[#8B5CF6] to-[#7C3AED]',
  avatar: 'https://randomuser.me/api/portraits/men/32.jpg'
}];
export function TransformationSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="w-full py-24 md:py-32 bg-[#0D002B]" data-id="element-214">
      <div className="max-w-6xl mx-auto px-6" data-id="element-215">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 30
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} data-id="element-216">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-20 text-center font-serif" data-id="element-217">
            Lo que dicen quienes ya lo aplicaron
          </h2>

          <div className="grid md:grid-cols-3 gap-8 md:gap-10" data-id="element-218">
            {testimonials.map((item, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 30
          }} animate={isInView ? {
            opacity: 1,
            y: 0
          } : {
            opacity: 0,
            y: 30
          }} transition={{
            duration: 0.6,
            delay: index * 0.15,
            ease: 'easeOut'
          }} className="bg-[#E0D7FF] rounded-[20px] border border-white p-8 md:p-10 shadow-[0_10px_40px_-15px_rgba(124,58,237,0.15)] flex flex-col" data-id="element-219">
                <div className="flex gap-1 mb-8" data-id="element-220">
                  {[1, 2, 3, 4, 5].map(star => <StarIcon key={star} className="w-5 h-5 text-[#E5A83B] fill-[#E5A83B]" data-id="element-221" />)}
                </div>

                <p className="text-[#1E0A3C] text-lg leading-relaxed mb-10 flex-1 font-sans italic font-medium" data-id="element-222">
                  "{item.text}"
                </p>

                <div className="flex items-center gap-4 mt-auto pt-6 border-t border-[#7C3AED]/20" data-id="element-223">
                  <div className="w-12 h-12 rounded-full flex-shrink-0 overflow-hidden border-2 border-white shadow-sm" data-id="element-224">
                    <img src={item.avatar} alt={item.author} className="w-full h-full object-cover" data-id="element-225" />
                  </div>
                  <div data-id="element-226">
                    <p className="font-bold text-[#1E0A3C] font-sans" data-id="element-227">
                      {item.author}
                    </p>
                    <p className="text-sm text-[#3B1F6E] font-sans" data-id="element-228">
                      {item.location}
                    </p>
                  </div>
                </div>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}